import React from 'react';
import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { IHotel, ISessionKey, ICar, ICondoLocation, IGroupedShareCompareHotel, IGroupedShareCompareCar, IGroupedShareCompareCondo, IShareCompareHotel, IShareCompareCar, IShareCompareCondo } from '@share/common-types';
import { IHotelInfo } from '@common-types';
import {
  IMarginatorState,
  hotelsActions,
  marginatorActions,
  ILoginState,
  ILocationsState,
  IMenuState,
  ICarLocationsState,
  ICarsDriverState,
  carsActions
} from '@share/store/slices';

import { ModalShareAll } from './modal-share/component';
import { RootState, LoginType, getSelectedCurrency, getCarCompareRoutePath, UrlUtils } from '@share/utils';
import { DownLoadShareType, HandleDownload, HandleShare } from '@share/api';
import { LOCATION_OBJECT_LABEL, NULL_VALUE } from '@constants';
import { get } from 'lodash';

import {
  hotelDetailsActions,
  roomsSearchActions
} from '@store/slices';

import { Modal, Tabs } from 'antd';

import 'moment/min/locales';

import { HotelTab } from './hotel-tab';
import { CarTab } from './car-tab';
import { CondoTab } from './condo-tab';

import './style.scss';
import moment from 'moment';

const modalWidth = 900;

interface IMapStateToProps {
  marginatorStore: IMarginatorState;
  loginStore: ILoginState;
  locationsStore: ILocationsState;
  menuStore: IMenuState;

  carsLocationsStore: ICarLocationsState;
  carsDriverStore: ICarsDriverState
}

interface IMapDispatchToProps {
  setCommission: (value: number) => void;
  setSupplier: (value: string) => void;
  setHotelDetails: (hotel: any) => void;
  setSelectedHotel: (hotel: IHotel) => void;
  resetState: () => void;

  setSelectedCar: (car: ICar) => void;
}

interface IProps extends IMapDispatchToProps, IMapStateToProps, WrappedComponentProps, RouteComponentProps {
  visible: boolean;
  locationCode: string;
  sessionKey: ISessionKey;
  hotels: Record<string, IGroupedShareCompareHotel[]>;
  isVacationRentals?: boolean | null | undefined;
  onHotelRemove: (hotel: IShareCompareHotel) => void;
  onHotelGroupRemove: (hotels: IShareCompareHotel[]) => void;

  cars: Record<string, IGroupedShareCompareCar[]>;
  carLocationCode: string;
  carSessionKey: ISessionKey | null | undefined;
  onCarRemove: (car: IShareCompareCar) => void;
  onCarGroupRemove: (cars: IShareCompareCar[]) => void;

  adultsCount: number;
  kidsCount: number;
  bedroomsCount: number;
  isFlexible: boolean;
  months?: string[];
  locationObject: ICondoLocation | null | undefined;
  condosessionKey: ISessionKey | null | undefined;
  condos: Record<string, IGroupedShareCompareCondo[]>;
  onCondoRemove: (condo: IShareCompareCondo) => void;
  onCondoGroupRemove: (condos: IShareCompareCondo[]) => void;

  onCancel: () => void;


}

interface IState {
  loading: boolean;
  visibleAction: boolean;
  isShare: boolean;
  activeKey: string;
  shareConfirmationMessage: string;
}


class ModalCompareComponent extends React.Component<IProps, IState> {

  state: IState = {
    loading: false,
    visibleAction: false,
    isShare: false,
    activeKey: '1',
    shareConfirmationMessage: '',
  };

  componentDidUpdate(prevProps: IProps) {
    const { hotels, cars, condos, visible } = this.props;
    const prevHotels = prevProps.hotels || {};
    const prevCars = prevProps.cars || {};
    const prevCondos = prevProps.condos || {};

    if ((visible && !prevProps.visible) ||
      (Object.keys(hotels || {}).length !== Object.keys(prevHotels).length) ||
      (Object.keys(cars || {}).length !== Object.keys(prevCars).length) ||
      (Object.keys(condos || {}).length !== Object.keys(prevCondos).length)) {
      this.setInitialActiveTab();
    }
  }

  setInitialActiveTab = () => {
    const { location, hotels = {}, cars = {}, condos = {} } = this.props;
    const path = location.pathname;
    let activeKey = '1';

    const hasHotels = Object.keys(hotels).length > 0;
    const hasCars = Object.keys(cars).length > 0;
    const hasCondos = Object.keys(condos).length > 0;

    if (path.includes('car') && hasCars) {
      activeKey = '2';
    } else if ((path.includes('condo') || path.includes('vacation')) && hasCondos) {
      activeKey = '3';
    } else if (hasHotels) {
      activeKey = '1';
    } else if (hasCars) {
      activeKey = '2';
    } else if (hasCondos) {
      activeKey = '3';
    }

    this.setState({ activeKey });
  }

  handleTabChange = (activeKey: string) => {
    this.setState({ activeKey });
  }

  getHotelPayload = (): any[] => {
    const { account } = this.props.loginStore;
    const isB2C = account?.isB2C;
    const value = this.props.marginatorStore.value || 0;

    return Object.values(this.props.hotels).flat().map((group) => {
      console.log(group, 'group');
      const firstHotel = group.items?.[0];
      const search = UrlUtils.getUrl(LOCATION_OBJECT_LABEL, firstHotel?.locationObj);
      const locationObject = search.split('&').find((x) => x.includes('locationObject'))?.substring(15);
      return {
        quotes: group.items.map((hotel) => {
          const marginatorPrice = hotel.price / (1 - value / 100);
          const savingsNunmber = (hotel.savings / marginatorPrice) * 100;
          const discount = savingsNunmber ? Math.floor(savingsNunmber) : 0;
          const publicPrice =
            isB2C || !hotel.publicPrices?.length ? null : Math.min(...hotel.publicPrices.map((p) => p.price));

          return {
            hotelId: hotel.hotelId,
            displayName: hotel.displayName,
            fullAddress: `${hotel.address}, ${hotel.city}, ${hotel.state}, ${hotel.countryCode}`,
            mealPLan: hotel.mealPLan,
            refundability: hotel.refundability,
            starRating: hotel.starRating,
            reviewsCount: hotel.rating?.reviewsCount,
            rating: hotel.rating?.value,
            currency: hotel.currency,
            price: marginatorPrice,
            publicPrice,
            discount,
            image: get(hotel, 'images[0].url'),
            amenities: hotel?.amenities?.map((a) => a.name),
          };
        }),
        location: locationObject,
        hotelRequest: {
          checkIn: group.startDate,
          checkOut: group.endDate,
          location: '',
          rooms: firstHotel?.rooms?.map((r) => ({
            adultsCount: r.adultsCount,
            kidsAges: r.kids?.map((k) => k.age || 0),
          })),
        },
        sessionKey: this.props.sessionKey,
      };
    });
  };

  getCarPayload = (): any[] => {
    const { account } = this.props.loginStore;
    const isB2C = account?.isB2C;
    const value = this.props.marginatorStore.value || 0;

    return Object.values(this.props.cars).flat().map((group) => {
      const firstCar = group.items?.[0];
      return {
        quotes: group.items.map((car) => {
          const marginatorPrice = car.price / (1 - value / 100);
          const publicPrice =
            isB2C || !car.publicPrices?.length ? null : Math.min(...car.publicPrices.map((p) => p.price));
          const carRoutePath = getCarCompareRoutePath(car.id, car.sessionKey);
          const carFullPath = `{0}{1}${carRoutePath}`;
          return {
            carId: car.id,
            displayName: car.vehicle?.vehMakeModel?.name,
            Category: car.vehicle?.category || NULL_VALUE,
            currency: car.currency,
            price: marginatorPrice,
            RentalCompany: car.vendor?.value || NULL_VALUE,
            RentalCompanyLogo: car?.info?.tpA_Extensions?.supplierLogo?.url || NULL_VALUE,
            publicPrice,
            IsRefundable: car.refundable,
            image: car.vehicle?.pictureURL,
            features: {
              seats: Number(car.vehicle?.passengerQuantity) || null,
              luggage: Number(car.vehicle?.baggageQuantity) || null,
              doors: Number((car.vehicle as any)?.vehType?.doorCount) || null,
              transmission: car.vehicle?.transmissionType,
              airConditioning: car.vehicle?.airConditionInd,
              unlimitedMileage: true,
            },
            pickUpDate: car.startDate,
            dropOffDate: car.endDate,
            pickUpLocation: car.pickUpLocationDetail?.name,
            dropOffLocation: car.dropOffLocationDetail?.name,
            driverAge: car.carRequest?.driverAge || 22,
            Link: carFullPath,
            carRequest: firstCar?.carRequest,
          };
        }),
        sessionKey: this.props.carSessionKey,
      };
    });
  };

  getCondoPayload = (): any[] => {
    const value = this.props.marginatorStore.value || 0;
    const currency = getSelectedCurrency(this.props.loginStore.account as any);
    
    return Object.values(this.props.condos).flat().map((group) => {
     
      return {
        quotes: group.items.map((condo) => {
          const marginatorPrice = (condo.price ? condo.price : 0) / (1 - value / 100);
          const savingsNunmber = (condo.savings / marginatorPrice) * 100;
          const discount = savingsNunmber ? Math.floor(savingsNunmber) : 0;
          return {
            condoId: condo.condoId,
            displayName: condo.displayName,
            fullAddress: condo.fullAddress,
            refundability: condo.refundability,
            reviewsCount: condo.rating?.reviewsCount,
            rating: condo.rating?.value,
            currency,
            price: marginatorPrice,
            publicPrice: condo.publicPrice,
            supplierType: (condo as any).supplierType,
            availableDates: condo.availableDates?.length
            ? [
                ...condo.availableDates?.map((ad) => ({
                  matchType: ad.matchType,
                  totalNights: moment(ad.to, 'yyyy-MM-DD').diff(moment(ad.from, 'yyyy-MM-DD'), 'days'),
                  from: ad.from,
                  to: ad.to,
                })),
              ]
            : [],
            discount,
            image: get(condo, 'images[0].url'),
            locationObj: (condo as any).locationObj,
          };
        }),
        searchType: group.searchType,
        condoRequest: {
          location: group.items[0].locationObj,
          months: group.selectedMonths?.map((m) => moment(m, 'DD MMM YYYY').format('YYYY-MM-DD')) ,
          adultsCount: group.adultsCount,
          kidsCount: group.kidsCount,
          childrenCount: group.kidsCount,
          bedroomsCount: group.bedroomsCount,
        },
        sessionKey: this.props.condosessionKey,
      };
    });
  };

  runAllRequests = (
    members: string[] | undefined,
    comment: string | undefined,
    runner: (type: DownLoadShareType, data: any, done: () => void) => void
  ) => {
    const payload: any = {
      comment,
      members: members || [],
      sendEmail: false,
    };

    if (Object.keys(this.props.hotels).length > 0) payload.hotelQuotes = this.getHotelPayload();
    if (Object.keys(this.props.cars).length > 0) payload.carQuotes = this.getCarPayload();
    if (Object.keys(this.props.condos).length > 0) payload.condoQuotes = this.getCondoPayload();

    if (Object.keys(payload).length <= 3) return;

    this.setState({ loading: true });
    runner(DownLoadShareType.MULTIPLE_QUOTES, payload, () => {
      this.setState({ loading: false, visibleAction: false, isShare: false });
    });
  };

  onSubmitDownloadAll = (comment: string) => {
    this.runAllRequests([], comment, (type, data, done) => {
      HandleDownload(type, false, data, this.props.intl, () => {}, done);
    });
  };

  onSubmitShareAll = (members: string[], comment: string) => {
    this.runAllRequests(members, comment, (type, data, done) => {
      HandleShare(type, false, { ...data, continue: false }, this.props.intl, () => {}, done, () => done());
    });
  };

  handelDownload = () => {
    const { account } = this.props.loginStore;
    if (!account || account.type !== LoginType.PrivateWithToken) {
      this.onSubmitDownloadAll('');
      return;
    }
    this.setState({ visibleAction: true, isShare: false });
  }

  handelShare = () => {
    const hotelCount = Object.values(this.props.hotels).flat().length;
    const carCount = Object.values(this.props.cars).flat().length;
    const condoCount = Object.values(this.props.condos).flat().length;

    const parts: string[] = [];
    if (hotelCount > 0) parts.push(`${hotelCount} hotel quote`);
    if (carCount > 0) parts.push(`${carCount} car quote`);
    if (condoCount > 0) parts.push(`${condoCount} condo quote`);

    const selectionText = parts.length ? parts.join(', ') : '0 quote';
    const message = `You have selected ${selectionText}. Are you sure?`;
    this.setState({ visibleAction: true, isShare: true, shareConfirmationMessage: message });
  }

  render(): React.ReactNode {
    const {
      visible,
      hotels = {},
      cars = {},
      condos = {},

      onCancel,
      onHotelRemove,
      onCarRemove,
      onCondoRemove,
      onHotelGroupRemove,
      onCarGroupRemove,
      onCondoGroupRemove,
    } = this.props;

    const { account } = this.props.loginStore;
    const fontFamily = account?.fontFamily;
    const secondaryFontFamily = account?.secondaryFontFamily;
    const { activeKey } = this.state;

    const items = [];
    if (Object.keys(hotels).length > 0) {
      items.push({
        key: '1',
        label: <FormattedMessage id="Hotels" />,
        children: (
          <HotelTab
            hotels={hotels}
            marginatorStore={this.props.marginatorStore}
            loginStore={this.props.loginStore}
            isVacationRentals={this.props.isVacationRentals}
            sessionKey={this.props.sessionKey}
            onHotelRemove={onHotelRemove}
            onHotelGroupRemove={onHotelGroupRemove}
            onCancel={onCancel}
            handelDownload={this.handelDownload}
            handelShare={this.handelShare}
          />
        ),
      });
    }

    if (Object.keys(cars).length > 0) {
      items.push({
        key: '2',
        label: <FormattedMessage id="Cars" />,
        children: (
          <CarTab
            cars={cars}
            marginatorStore={this.props.marginatorStore}
            loginStore={this.props.loginStore}
            onCarRemove={onCarRemove}
            onCarGroupRemove={onCarGroupRemove}
            onCancel={onCancel}
            handelDownload={this.handelDownload}
            handelShare={this.handelShare}
          />
        ),
      });
    }

    if (Object.keys(condos).length > 0) {
      items.push({
        key: '3',
        label: <FormattedMessage id="Condos" />,
        children: (
          <CondoTab
            condos={condos}
            marginatorStore={this.props.marginatorStore}
            loginStore={this.props.loginStore}
            condosessionKey={this.props.condosessionKey}
            onCondoRemove={onCondoRemove}
            onCondoGroupRemove={onCondoGroupRemove}
            onCancel={onCancel}
            handelDownload={this.handelDownload}
            handelShare={this.handelShare}
          />
        ),
      });
    }

    return (
      <Modal
        className={`modal-compare ${fontFamily ? `${fontFamily}-font` : ''} ${secondaryFontFamily ? `secondary-${secondaryFontFamily}-font` : ''}`}
        open={visible}
        footer={null}
        onCancel={onCancel}
        wrapClassName="modal-compare__wrapper quote-modal"
        width={modalWidth}
      >
        <Tabs activeKey={activeKey} items={items} onChange={this.handleTabChange} />
        <ModalShareAll
          visible={this.state.visibleAction}
          isShare={this.state.isShare}
          loading={this.state.loading}
          shareConfirmationMessage={this.state.shareConfirmationMessage}
          onCancel={() => this.setState({ visibleAction: false, isShare: false })}
          onDownload={this.onSubmitDownloadAll}
          onShare={this.onSubmitShareAll}
        />

      </Modal>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    marginatorStore: state.marginatorStore,
    loginStore: state.loginStore,
    locationsStore: state.locationsStore,
    menuStore: state.navigationMenuStore,

    carsLocationsStore: state.carsLocationsStore,
    carsDriverStore: state.carsDriverStore,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, any, Action>): IMapDispatchToProps => ({
  setCommission: (value: number) => {
    dispatch(marginatorActions.setCommission(value));
  },
  setSupplier: (value: string) => {
    dispatch(marginatorActions.setSupplier(value));
  },
  setHotelDetails: (hotel: IHotelInfo) => dispatch(hotelDetailsActions.setHotelDetails(hotel)),
  setSelectedHotel: (hotel: IHotel) => dispatch(hotelsActions.setSelectedHotel(hotel)),
  resetState: () => dispatch(roomsSearchActions.resetState()),
  setSelectedCar: (car: ICar) => {
    dispatch(carsActions.setSelectedCar(car));
  },
});

export const ModalCompare = connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(ModalCompareComponent)));
